<template>
    <q-item v-bind="$attrs">
        <q-item-section>
            <q-item-label><strong>{{ userName }}</strong> user account activated.</q-item-label>
            <q-item-label caption>
                <slot></slot>
            </q-item-label>
        </q-item-section>
    </q-item>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

interface UserActivated {
  id: number,
  firstName: string,
  lastName: string,
}

export default defineComponent({
  props: {
    data: {
      type: Object as () => UserActivated,
      required: true,
    },
  },
  computed: {
    userName(): string {
      return `${this.data.firstName} ${this.data.lastName}`;
    },
  },
});
</script>
